@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-729_137_826)
public val Res.string.error_recent_login: StringResource by lazy {
      StringResource("string:error_recent_login", "error_recent_login", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 123803, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 174067, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111858, 62),
      ))
    }

@delegate:ResourceContentHash(1_758_610_155)
public val Res.string.error_request_limit: StringResource by lazy {
      StringResource("string:error_request_limit", "error_request_limit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 123882, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 174166, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111921, 79),
      ))
    }

@delegate:ResourceContentHash(1_639_582_391)
public val Res.string.error_roster_exists: StringResource by lazy {
      StringResource("string:error_roster_exists", "error_roster_exists", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 123954, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 174266, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112001, 79),
      ))
    }

@delegate:ResourceContentHash(931_060_218)
public val Res.string.error_save_failed: StringResource by lazy {
      StringResource("string:error_save_failed", "error_save_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 124034, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 174370, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112081, 53),
      ))
    }

@delegate:ResourceContentHash(-1_193_571_339)
public val Res.string.error_send_failed: StringResource by lazy {
      StringResource("string:error_send_failed", "error_send_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 124100, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 174452, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112135, 53),
      ))
    }

@delegate:ResourceContentHash(2_132_379_905)
public val Res.string.error_session_expired: StringResource by lazy {
      StringResource("string:error_session_expired", "error_session_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 124166, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 174538, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112189, 85),
      ))
    }

@delegate:ResourceContentHash(-1_343_024_779)
public val Res.string.error_sign_in_method_disabled: StringResource by lazy {
      StringResource("string:error_sign_in_method_disabled", "error_sign_in_method_disabled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 124248, 145),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 174648, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112275, 129),
      ))
    }

@delegate:ResourceContentHash(-973_330_834)
public val Res.string.error_sign_in_not_set_up_desktop: StringResource by lazy {
      StringResource("string:error_sign_in_not_set_up_desktop", "error_sign_in_not_set_up_desktop", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 124394, 204),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 174826, 300),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112405, 200),
      ))
    }

@delegate:ResourceContentHash(1_724_003_699)
public val Res.string.error_sign_out_failed: StringResource by lazy {
      StringResource("string:error_sign_out_failed", "error_sign_out_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 124599, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 175127, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112606, 65),
      ))
    }

@delegate:ResourceContentHash(984_291_874)
public val Res.string.error_state_retry: StringResource by lazy {
      StringResource("string:error_state_retry", "error_state_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 124673, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 175205, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112672, 37),
      ))
    }

@delegate:ResourceContentHash(869_888_817)
public val Res.string.error_state_title: StringResource by lazy {
      StringResource("string:error_state_title", "error_state_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 124723, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 175275, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112710, 53),
      ))
    }

@delegate:ResourceContentHash(1_606_343_788)
public val Res.string.error_too_many_requests: StringResource by lazy {
      StringResource("string:error_too_many_requests", "error_too_many_requests", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 124793, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 175369, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112764, 95),
      ))
    }

@delegate:ResourceContentHash(1_119_143_842)
public val Res.string.error_user_not_found: StringResource by lazy {
      StringResource("string:error_user_not_found", "error_user_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 124901, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 175517, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112860, 92),
      ))
    }

@delegate:ResourceContentHash(-829_863_142)
public val Res.string.error_weak_password: StringResource by lazy {
      StringResource("string:error_weak_password", "error_weak_password", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125006, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 175670, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112953, 99),
      ))
    }

@delegate:ResourceContentHash(-1_807_417_193)
public val Res.string.error_workplace_name_required: StringResource by lazy {
      StringResource("string:error_workplace_name_required", "error_workplace_name_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125102, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 175834, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113053, 73),
      ))
    }

@delegate:ResourceContentHash(1_834_315_191)
public val Res.string.event_badge: StringResource by lazy {
      StringResource("string:event_badge", "event_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125190, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 175958, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113149, 39),
      ))
    }

@delegate:ResourceContentHash(925_147_573)
public val Res.string.explain_available: StringResource by lazy {
      StringResource("string:explain_available", "explain_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125238, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176018, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113189, 53),
      ))
    }

@delegate:ResourceContentHash(1_764_742_661)
public val Res.string.explain_days: StringResource by lazy {
      StringResource("string:explain_days", "explain_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125340, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176148, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113291, 36),
      ))
    }

@delegate:ResourceContentHash(1_493_532_792)
public val Res.string.explain_days_of: StringResource by lazy {
      StringResource("string:explain_days_of", "explain_days_of", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125292, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176096, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113243, 47),
      ))
    }

@delegate:ResourceContentHash(1_584_553_984)
public val Res.string.explain_employee_line: StringResource by lazy {
      StringResource("string:explain_employee_line", "explain_employee_line", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125373, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176185, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113328, 49),
      ))
    }

@delegate:ResourceContentHash(-865_245_137)
public val Res.string.explain_employer_line: StringResource by lazy {
      StringResource("string:explain_employer_line", "explain_employer_line", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125427, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176251, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113378, 49),
      ))
    }

@delegate:ResourceContentHash(133_188_118)
public val Res.string.explain_empty: StringResource by lazy {
      StringResource("string:explain_empty", "explain_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125481, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176325, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113428, 53),
      ))
    }

@delegate:ResourceContentHash(368_963_397)
public val Res.string.explain_figure_budget_used: StringResource by lazy {
      StringResource("string:explain_figure_budget_used", "explain_figure_budget_used", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125547, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176419, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113482, 58),
      ))
    }

@delegate:ResourceContentHash(-1_597_638_897)
public val Res.string.explain_figure_costs: StringResource by lazy {
      StringResource("string:explain_figure_costs", "explain_figure_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125622, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176534, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113541, 36),
      ))
    }

@delegate:ResourceContentHash(-214_335_429)
public val Res.string.explain_figure_employer_cost: StringResource by lazy {
      StringResource("string:explain_figure_employer_cost", "explain_figure_employer_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125659, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176583, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113578, 56),
      ))
    }

@delegate:ResourceContentHash(-12_382_491)
public val Res.string.explain_figure_fixed_costs: StringResource by lazy {
      StringResource("string:explain_figure_fixed_costs", "explain_figure_fixed_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125720, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176672, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113635, 50),
      ))
    }

@delegate:ResourceContentHash(-783_010_447)
public val Res.string.explain_figure_fixed_revenue: StringResource by lazy {
      StringResource("string:explain_figure_fixed_revenue", "explain_figure_fixed_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125775, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176751, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113686, 56),
      ))
    }

@delegate:ResourceContentHash(-867_048_819)
public val Res.string.explain_figure_gross: StringResource by lazy {
      StringResource("string:explain_figure_gross", "explain_figure_gross", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125836, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176832, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113743, 36),
      ))
    }

@delegate:ResourceContentHash(-719_248_935)
public val Res.string.explain_figure_income: StringResource by lazy {
      StringResource("string:explain_figure_income", "explain_figure_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125873, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176877, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113780, 37),
      ))
    }

@delegate:ResourceContentHash(480_798_000)
public val Res.string.explain_figure_labour_cost: StringResource by lazy {
      StringResource("string:explain_figure_labour_cost", "explain_figure_labour_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125915, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 176923, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113818, 50),
      ))
    }

@delegate:ResourceContentHash(-1_207_511_178)
public val Res.string.explain_figure_labour_percent: StringResource by lazy {
      StringResource("string:explain_figure_labour_percent", "explain_figure_labour_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126053, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 177141, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113940, 49),
      ))
    }

@delegate:ResourceContentHash(-51_957_788)
public val Res.string.explain_figure_labour_percent_of_sales: StringResource by lazy {
      StringResource("string:explain_figure_labour_percent_of_sales", "explain_figure_labour_percent_of_sales", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 125966, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 177006, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113869, 70),
      ))
    }

@delegate:ResourceContentHash(903_205_032)
public val Res.string.explain_figure_margin: StringResource by lazy {
      StringResource("string:explain_figure_margin", "explain_figure_margin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126111, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 177235, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113990, 37),
      ))
    }

@delegate:ResourceContentHash(-1_498_840_952)
public val Res.string.explain_figure_month_items: StringResource by lazy {
      StringResource("string:explain_figure_month_items", "explain_figure_month_items", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126149, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 177281, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114028, 102),
      ))
    }

@delegate:ResourceContentHash(-1_365_715_965)
public val Res.string.explain_figure_net_sales: StringResource by lazy {
      StringResource("string:explain_figure_net_sales", "explain_figure_net_sales", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126236, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 177412, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114131, 44),
      ))
    }

@delegate:ResourceContentHash(-1_634_148_975)
public val Res.string.explain_figure_one_off_costs: StringResource by lazy {
      StringResource("string:explain_figure_one_off_costs", "explain_figure_one_off_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126289, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 177481, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114176, 56),
      ))
    }

@delegate:ResourceContentHash(1_182_720_509)
public val Res.string.explain_figure_one_off_revenue: StringResource by lazy {
      StringResource("string:explain_figure_one_off_revenue", "explain_figure_one_off_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126350, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 177554, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114233, 58),
      ))
    }

@delegate:ResourceContentHash(870_414_098)
public val Res.string.explain_figure_other_costs: StringResource by lazy {
      StringResource("string:explain_figure_other_costs", "explain_figure_other_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126417, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 177629, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114292, 62),
      ))
    }

@delegate:ResourceContentHash(684_389_285)
public val Res.string.explain_figure_pay_change: StringResource by lazy {
      StringResource("string:explain_figure_pay_change", "explain_figure_pay_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126480, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 177724, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114355, 73),
      ))
    }

@delegate:ResourceContentHash(30_769_660)
public val Res.string.explain_figure_recurring_revenue: StringResource by lazy {
      StringResource("string:explain_figure_recurring_revenue", "explain_figure_recurring_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126558, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 177822, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114429, 64),
      ))
    }

@delegate:ResourceContentHash(-1_223_248_724)
public val Res.string.explain_figure_result: StringResource by lazy {
      StringResource("string:explain_figure_result", "explain_figure_result", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126627, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 177907, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114494, 37),
      ))
    }

@delegate:ResourceContentHash(-1_568_102_855)
public val Res.string.explain_figure_revenue: StringResource by lazy {
      StringResource("string:explain_figure_revenue", "explain_figure_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126665, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 177961, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114532, 42),
      ))
    }

@delegate:ResourceContentHash(797_660_278)
public val Res.string.explain_figure_sales_income: StringResource by lazy {
      StringResource("string:explain_figure_sales_income", "explain_figure_sales_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126708, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 178008, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114575, 51),
      ))
    }

@delegate:ResourceContentHash(-1_902_735_166)
public val Res.string.explain_figure_sales_target: StringResource by lazy {
      StringResource("string:explain_figure_sales_target", "explain_figure_sales_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126776, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 178092, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114627, 51),
      ))
    }

@delegate:ResourceContentHash(-1_536_945_261)
public val Res.string.explain_figure_shared_costs: StringResource by lazy {
      StringResource("string:explain_figure_shared_costs", "explain_figure_shared_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126832, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 178164, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114679, 63),
      ))
    }

@delegate:ResourceContentHash(499_235_261)
public val Res.string.explain_figure_shift_cost: StringResource by lazy {
      StringResource("string:explain_figure_shift_cost", "explain_figure_shift_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126896, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 178264, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114743, 49),
      ))
    }

@delegate:ResourceContentHash(-1_528_705_559)
public val Res.string.explain_figure_shifts_employer_cost: StringResource by lazy {
      StringResource("string:explain_figure_shifts_employer_cost", "explain_figure_shifts_employer_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 126946, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 178334, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114793, 67),
      ))
    }

@delegate:ResourceContentHash(1_960_952_573)
public val Res.string.explain_figure_spmh: StringResource by lazy {
      StringResource("string:explain_figure_spmh", "explain_figure_spmh", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 127006, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 178406, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114861, 59),
      ))
    }

@delegate:ResourceContentHash(-1_186_011_092)
public val Res.string.explain_figure_staffing_labour_percent: StringResource by lazy {
      StringResource("string:explain_figure_staffing_labour_percent", "explain_figure_staffing_labour_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 127082, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 178502, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114921, 66),
      ))
    }

@delegate:ResourceContentHash(-1_146_577_553)
public val Res.string.explain_figure_take_home: StringResource by lazy {
      StringResource("string:explain_figure_take_home", "explain_figure_take_home", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 127153, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 178609, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114988, 56),
      ))
    }

@delegate:ResourceContentHash(-2_051_114_157)
public val Res.string.explain_figure_takings: StringResource by lazy {
      StringResource("string:explain_figure_takings", "explain_figure_takings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 127214, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 178690, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115045, 42),
      ))
    }

@delegate:ResourceContentHash(-1_501_583_547)
public val Res.string.explain_formula_budget_used: StringResource by lazy {
      StringResource("string:explain_formula_budget_used", "explain_formula_budget_used", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 127253, 199),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 178737, 315),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115088, 187),
      ))
    }

@delegate:ResourceContentHash(1_854_043_360)
public val Res.string.explain_formula_costs: StringResource by lazy {
      StringResource("string:explain_formula_costs", "explain_formula_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 127453, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 179053, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115276, 73),
      ))
    }

@delegate:ResourceContentHash(789_208_255)
public val Res.string.explain_formula_employer_cost: StringResource by lazy {
      StringResource("string:explain_formula_employer_cost", "explain_formula_employer_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 127531, 133),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 179179, 209),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115350, 141),
      ))
    }

@delegate:ResourceContentHash(-1_235_634_443)
public val Res.string.explain_formula_fixed_costs: StringResource by lazy {
      StringResource("string:explain_formula_fixed_costs", "explain_formula_fixed_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 127665, 123),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 179389, 199),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115492, 123),
      ))
    }

@delegate:ResourceContentHash(827_135_370)
public val Res.string.explain_formula_fixed_revenue: StringResource by lazy {
      StringResource("string:explain_formula_fixed_revenue", "explain_formula_fixed_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 127789, 169),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 179589, 273),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115616, 177),
      ))
    }

@delegate:ResourceContentHash(207_870_811)
public val Res.string.explain_formula_gross: StringResource by lazy {
      StringResource("string:explain_formula_gross", "explain_formula_gross", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 127959, 125),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 179863, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115794, 133),
      ))
    }

@delegate:ResourceContentHash(-367_088_835)
public val Res.string.explain_formula_income: StringResource by lazy {
      StringResource("string:explain_formula_income", "explain_formula_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 128085, 162),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 180037, 262),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115928, 178),
      ))
    }

@delegate:ResourceContentHash(-879_264_005)
public val Res.string.explain_formula_labour_cost: StringResource by lazy {
      StringResource("string:explain_formula_labour_cost", "explain_formula_labour_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 128248, 199),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 180300, 331),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116107, 207),
      ))
    }

@delegate:ResourceContentHash(-244_842_508)
public val Res.string.explain_formula_labour_percent: StringResource by lazy {
      StringResource("string:explain_formula_labour_percent", "explain_formula_labour_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 128548, 210),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 180780, 334),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116407, 210),
      ))
    }

@delegate:ResourceContentHash(-1_667_522_021)
public val Res.string.explain_formula_labour_percent_of_sales: StringResource by lazy {
      StringResource("string:explain_formula_labour_percent_of_sales", "explain_formula_labour_percent_of_sales", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 128448, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 180632, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116315, 91),
      ))
    }

@delegate:ResourceContentHash(1_045_027_259)
public val Res.string.explain_formula_margin: StringResource by lazy {
      StringResource("string:explain_formula_margin", "explain_formula_margin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 128759, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 181115, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116618, 66),
      ))
    }

@delegate:ResourceContentHash(-1_566_899_778)
public val Res.string.explain_formula_month_items: StringResource by lazy {
      StringResource("string:explain_formula_month_items", "explain_formula_month_items", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 128826, 267),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 181202, 451),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116685, 235),
      ))
    }

@delegate:ResourceContentHash(-1_943_436_465)
public val Res.string.explain_formula_net_sales: StringResource by lazy {
      StringResource("string:explain_formula_net_sales", "explain_formula_net_sales", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 129094, 129),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 181654, 193),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116921, 141),
      ))
    }

@delegate:ResourceContentHash(845_134_344)
public val Res.string.explain_formula_one_off_costs: StringResource by lazy {
      StringResource("string:explain_formula_one_off_costs", "explain_formula_one_off_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 129224, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 181848, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117063, 73),
      ))
    }

@delegate:ResourceContentHash(1_923_544_084)
public val Res.string.explain_formula_one_off_revenue: StringResource by lazy {
      StringResource("string:explain_formula_one_off_revenue", "explain_formula_one_off_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 129306, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 181966, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117137, 87),
      ))
    }

@delegate:ResourceContentHash(569_025_357)
public val Res.string.explain_formula_other_costs: StringResource by lazy {
      StringResource("string:explain_formula_other_costs", "explain_formula_other_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 129406, 123),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 182098, 175),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117225, 127),
      ))
    }

@delegate:ResourceContentHash(-297_859_163)
public val Res.string.explain_formula_pay_change: StringResource by lazy {
      StringResource("string:explain_formula_pay_change", "explain_formula_pay_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 129530, 250),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 182274, 374),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117353, 266),
      ))
    }

@delegate:ResourceContentHash(778_351_803)
public val Res.string.explain_formula_recurring_revenue: StringResource by lazy {
      StringResource("string:explain_formula_recurring_revenue", "explain_formula_recurring_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 129781, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 182649, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117620, 113),
      ))
    }

@delegate:ResourceContentHash(1_341_975_339)
public val Res.string.explain_formula_result: StringResource by lazy {
      StringResource("string:explain_formula_result", "explain_formula_result", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 129899, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 182811, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117734, 54),
      ))
    }

@delegate:ResourceContentHash(-977_014_890)
public val Res.string.explain_formula_revenue: StringResource by lazy {
      StringResource("string:explain_formula_revenue", "explain_formula_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 129958, 139),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 182882, 207),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117789, 135),
      ))
    }

@delegate:ResourceContentHash(-920_135_980)
public val Res.string.explain_formula_sales_income: StringResource by lazy {
      StringResource("string:explain_formula_sales_income", "explain_formula_sales_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 130098, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 183090, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 117925, 120),
      ))
    }

@delegate:ResourceContentHash(-1_934_546_802)
public val Res.string.explain_formula_sales_target: StringResource by lazy {
      StringResource("string:explain_formula_sales_target", "explain_formula_sales_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 130219, 152),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 183259, 248),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 118046, 152),
      ))
    }

@delegate:ResourceContentHash(-1_504_593_607)
public val Res.string.explain_formula_shared_costs: StringResource by lazy {
      StringResource("string:explain_formula_shared_costs", "explain_formula_shared_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 130372, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 183508, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 118199, 116),
      ))
    }

@delegate:ResourceContentHash(740_192_650)
public val Res.string.explain_formula_shift_cost: StringResource by lazy {
      StringResource("string:explain_formula_shift_cost", "explain_formula_shift_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 130493, 206),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 183693, 298),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 118316, 190),
      ))
    }

@delegate:ResourceContentHash(419_305_961)
public val Res.string.explain_formula_shifts_employer_cost: StringResource by lazy {
      StringResource("string:explain_formula_shifts_employer_cost", "explain_formula_shifts_employer_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 130700, 160),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 183992, 268),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 118507, 152),
      ))
    }

@delegate:ResourceContentHash(375_334_220)
public val Res.string.explain_formula_spmh: StringResource by lazy {
      StringResource("string:explain_formula_spmh", "explain_formula_spmh", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 130861, 500),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 184261, 800),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 118660, 400),
      ))
    }

@delegate:ResourceContentHash(1_259_619_946)
public val Res.string.explain_formula_staffing_labour_percent: StringResource by lazy {
      StringResource("string:explain_formula_staffing_labour_percent", "explain_formula_staffing_labour_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 131362, 191),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 185062, 327),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119061, 179),
      ))
    }

@delegate:ResourceContentHash(1_757_743_101)
public val Res.string.explain_formula_take_home: StringResource by lazy {
      StringResource("string:explain_formula_take_home", "explain_formula_take_home", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 131554, 137),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 185390, 217),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119241, 141),
      ))
    }

@delegate:ResourceContentHash(235_433_679)
public val Res.string.explain_formula_takings: StringResource by lazy {
      StringResource("string:explain_formula_takings", "explain_formula_takings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 131692, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 185608, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119383, 63),
      ))
    }

@delegate:ResourceContentHash(2_055_122_717)
public val Res.string.explain_hours: StringResource by lazy {
      StringResource("string:explain_hours", "explain_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 131807, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 185763, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119498, 29),
      ))
    }

@delegate:ResourceContentHash(-1_553_121_221)
public val Res.string.explain_hours_rate: StringResource by lazy {
      StringResource("string:explain_hours_rate", "explain_hours_rate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 131756, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 185700, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119447, 50),
      ))
    }

@delegate:ResourceContentHash(833_734_750)
public val Res.string.explain_not_counted: StringResource by lazy {
      StringResource("string:explain_not_counted", "explain_not_counted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 131837, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 185801, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119528, 43),
      ))
    }

@delegate:ResourceContentHash(-599_919_951)
public val Res.string.explain_note: StringResource by lazy {
      StringResource("string:explain_note", "explain_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 131885, 160),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 185861, 276),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119572, 120),
      ))
    }

@delegate:ResourceContentHash(-1_364_746_633)
public val Res.string.explain_open_shifts_count: StringResource by lazy {
      StringResource("string:explain_open_shifts_count", "explain_open_shifts_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132046, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 186138, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119693, 49),
      ))
    }

@delegate:ResourceContentHash(1_696_704_142)
public val Res.string.explain_open_shifts_set_rate: StringResource by lazy {
      StringResource("string:explain_open_shifts_set_rate", "explain_open_shifts_set_rate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132096, 172),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 186196, 304),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119743, 164),
      ))
    }

@delegate:ResourceContentHash(-262_715_820)
public val Res.string.explain_per_hour: StringResource by lazy {
      StringResource("string:explain_per_hour", "explain_per_hour", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132269, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 186501, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119908, 52),
      ))
    }

@delegate:ResourceContentHash(-273_323_902)
public val Res.string.explain_percent_of: StringResource by lazy {
      StringResource("string:explain_percent_of", "explain_percent_of", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132322, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 186562, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119961, 42),
      ))
    }

@delegate:ResourceContentHash(-717_646_591)
public val Res.string.explain_person_not_counted: StringResource by lazy {
      StringResource("string:explain_person_not_counted", "explain_person_not_counted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132365, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 186605, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120004, 90),
      ))
    }

@delegate:ResourceContentHash(1_961_715_285)
public val Res.string.explain_person_unpaid: StringResource by lazy {
      StringResource("string:explain_person_unpaid", "explain_person_unpaid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132444, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 186756, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120095, 61),
      ))
    }

@delegate:ResourceContentHash(205_508_501)
public val Res.string.explain_person_without_pay: StringResource by lazy {
      StringResource("string:explain_person_without_pay", "explain_person_without_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132518, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 186838, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120157, 58),
      ))
    }

@delegate:ResourceContentHash(-1_016_374_289)
public val Res.string.explain_ratio: StringResource by lazy {
      StringResource("string:explain_ratio", "explain_ratio", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132601, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 186929, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120216, 57),
      ))
    }

@delegate:ResourceContentHash(-1_692_422_169)
public val Res.string.explain_shifts_hours: StringResource by lazy {
      StringResource("string:explain_shifts_hours", "explain_shifts_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132659, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 186987, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120274, 60),
      ))
    }

@delegate:ResourceContentHash(174_780_603)
public val Res.string.explain_show: StringResource by lazy {
      StringResource("string:explain_show", "explain_show", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132777, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 187149, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120400, 52),
      ))
    }

@delegate:ResourceContentHash(-360_067_779)
public val Res.string.explain_show_how: StringResource by lazy {
      StringResource("string:explain_show_how", "explain_show_how", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132720, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 187060, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120335, 64),
      ))
    }

@delegate:ResourceContentHash(2_131_691_625)
public val Res.string.explain_side_actual: StringResource by lazy {
      StringResource("string:explain_side_actual", "explain_side_actual", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132822, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 187214, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120453, 47),
      ))
    }

@delegate:ResourceContentHash(-436_445_643)
public val Res.string.explain_side_forecast: StringResource by lazy {
      StringResource("string:explain_side_forecast", "explain_side_forecast", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132874, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 187282, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120501, 93),
      ))
    }

@delegate:ResourceContentHash(828_978_801)
public val Res.string.explain_side_plan: StringResource by lazy {
      StringResource("string:explain_side_plan", "explain_side_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132956, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 187380, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120595, 33),
      ))
    }

@delegate:ResourceContentHash(-127_550_320)
public val Res.string.explain_someone: StringResource by lazy {
      StringResource("string:explain_someone", "explain_someone", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 132990, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 187418, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120629, 63),
      ))
    }

@delegate:ResourceContentHash(1_684_806_890)
public val Res.string.explain_spmh_hours_planned: StringResource by lazy {
      StringResource("string:explain_spmh_hours_planned", "explain_spmh_hours_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 133054, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 187522, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120693, 54),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString15Resources(map: MutableMap<String, StringResource>) {
  map.put("error_recent_login", Res.string.error_recent_login)
  map.put("error_request_limit", Res.string.error_request_limit)
  map.put("error_roster_exists", Res.string.error_roster_exists)
  map.put("error_save_failed", Res.string.error_save_failed)
  map.put("error_send_failed", Res.string.error_send_failed)
  map.put("error_session_expired", Res.string.error_session_expired)
  map.put("error_sign_in_method_disabled", Res.string.error_sign_in_method_disabled)
  map.put("error_sign_in_not_set_up_desktop", Res.string.error_sign_in_not_set_up_desktop)
  map.put("error_sign_out_failed", Res.string.error_sign_out_failed)
  map.put("error_state_retry", Res.string.error_state_retry)
  map.put("error_state_title", Res.string.error_state_title)
  map.put("error_too_many_requests", Res.string.error_too_many_requests)
  map.put("error_user_not_found", Res.string.error_user_not_found)
  map.put("error_weak_password", Res.string.error_weak_password)
  map.put("error_workplace_name_required", Res.string.error_workplace_name_required)
  map.put("event_badge", Res.string.event_badge)
  map.put("explain_available", Res.string.explain_available)
  map.put("explain_days", Res.string.explain_days)
  map.put("explain_days_of", Res.string.explain_days_of)
  map.put("explain_employee_line", Res.string.explain_employee_line)
  map.put("explain_employer_line", Res.string.explain_employer_line)
  map.put("explain_empty", Res.string.explain_empty)
  map.put("explain_figure_budget_used", Res.string.explain_figure_budget_used)
  map.put("explain_figure_costs", Res.string.explain_figure_costs)
  map.put("explain_figure_employer_cost", Res.string.explain_figure_employer_cost)
  map.put("explain_figure_fixed_costs", Res.string.explain_figure_fixed_costs)
  map.put("explain_figure_fixed_revenue", Res.string.explain_figure_fixed_revenue)
  map.put("explain_figure_gross", Res.string.explain_figure_gross)
  map.put("explain_figure_income", Res.string.explain_figure_income)
  map.put("explain_figure_labour_cost", Res.string.explain_figure_labour_cost)
  map.put("explain_figure_labour_percent", Res.string.explain_figure_labour_percent)
  map.put("explain_figure_labour_percent_of_sales", Res.string.explain_figure_labour_percent_of_sales)
  map.put("explain_figure_margin", Res.string.explain_figure_margin)
  map.put("explain_figure_month_items", Res.string.explain_figure_month_items)
  map.put("explain_figure_net_sales", Res.string.explain_figure_net_sales)
  map.put("explain_figure_one_off_costs", Res.string.explain_figure_one_off_costs)
  map.put("explain_figure_one_off_revenue", Res.string.explain_figure_one_off_revenue)
  map.put("explain_figure_other_costs", Res.string.explain_figure_other_costs)
  map.put("explain_figure_pay_change", Res.string.explain_figure_pay_change)
  map.put("explain_figure_recurring_revenue", Res.string.explain_figure_recurring_revenue)
  map.put("explain_figure_result", Res.string.explain_figure_result)
  map.put("explain_figure_revenue", Res.string.explain_figure_revenue)
  map.put("explain_figure_sales_income", Res.string.explain_figure_sales_income)
  map.put("explain_figure_sales_target", Res.string.explain_figure_sales_target)
  map.put("explain_figure_shared_costs", Res.string.explain_figure_shared_costs)
  map.put("explain_figure_shift_cost", Res.string.explain_figure_shift_cost)
  map.put("explain_figure_shifts_employer_cost", Res.string.explain_figure_shifts_employer_cost)
  map.put("explain_figure_spmh", Res.string.explain_figure_spmh)
  map.put("explain_figure_staffing_labour_percent", Res.string.explain_figure_staffing_labour_percent)
  map.put("explain_figure_take_home", Res.string.explain_figure_take_home)
  map.put("explain_figure_takings", Res.string.explain_figure_takings)
  map.put("explain_formula_budget_used", Res.string.explain_formula_budget_used)
  map.put("explain_formula_costs", Res.string.explain_formula_costs)
  map.put("explain_formula_employer_cost", Res.string.explain_formula_employer_cost)
  map.put("explain_formula_fixed_costs", Res.string.explain_formula_fixed_costs)
  map.put("explain_formula_fixed_revenue", Res.string.explain_formula_fixed_revenue)
  map.put("explain_formula_gross", Res.string.explain_formula_gross)
  map.put("explain_formula_income", Res.string.explain_formula_income)
  map.put("explain_formula_labour_cost", Res.string.explain_formula_labour_cost)
  map.put("explain_formula_labour_percent", Res.string.explain_formula_labour_percent)
  map.put("explain_formula_labour_percent_of_sales", Res.string.explain_formula_labour_percent_of_sales)
  map.put("explain_formula_margin", Res.string.explain_formula_margin)
  map.put("explain_formula_month_items", Res.string.explain_formula_month_items)
  map.put("explain_formula_net_sales", Res.string.explain_formula_net_sales)
  map.put("explain_formula_one_off_costs", Res.string.explain_formula_one_off_costs)
  map.put("explain_formula_one_off_revenue", Res.string.explain_formula_one_off_revenue)
  map.put("explain_formula_other_costs", Res.string.explain_formula_other_costs)
  map.put("explain_formula_pay_change", Res.string.explain_formula_pay_change)
  map.put("explain_formula_recurring_revenue", Res.string.explain_formula_recurring_revenue)
  map.put("explain_formula_result", Res.string.explain_formula_result)
  map.put("explain_formula_revenue", Res.string.explain_formula_revenue)
  map.put("explain_formula_sales_income", Res.string.explain_formula_sales_income)
  map.put("explain_formula_sales_target", Res.string.explain_formula_sales_target)
  map.put("explain_formula_shared_costs", Res.string.explain_formula_shared_costs)
  map.put("explain_formula_shift_cost", Res.string.explain_formula_shift_cost)
  map.put("explain_formula_shifts_employer_cost", Res.string.explain_formula_shifts_employer_cost)
  map.put("explain_formula_spmh", Res.string.explain_formula_spmh)
  map.put("explain_formula_staffing_labour_percent", Res.string.explain_formula_staffing_labour_percent)
  map.put("explain_formula_take_home", Res.string.explain_formula_take_home)
  map.put("explain_formula_takings", Res.string.explain_formula_takings)
  map.put("explain_hours", Res.string.explain_hours)
  map.put("explain_hours_rate", Res.string.explain_hours_rate)
  map.put("explain_not_counted", Res.string.explain_not_counted)
  map.put("explain_note", Res.string.explain_note)
  map.put("explain_open_shifts_count", Res.string.explain_open_shifts_count)
  map.put("explain_open_shifts_set_rate", Res.string.explain_open_shifts_set_rate)
  map.put("explain_per_hour", Res.string.explain_per_hour)
  map.put("explain_percent_of", Res.string.explain_percent_of)
  map.put("explain_person_not_counted", Res.string.explain_person_not_counted)
  map.put("explain_person_unpaid", Res.string.explain_person_unpaid)
  map.put("explain_person_without_pay", Res.string.explain_person_without_pay)
  map.put("explain_ratio", Res.string.explain_ratio)
  map.put("explain_shifts_hours", Res.string.explain_shifts_hours)
  map.put("explain_show", Res.string.explain_show)
  map.put("explain_show_how", Res.string.explain_show_how)
  map.put("explain_side_actual", Res.string.explain_side_actual)
  map.put("explain_side_forecast", Res.string.explain_side_forecast)
  map.put("explain_side_plan", Res.string.explain_side_plan)
  map.put("explain_someone", Res.string.explain_someone)
  map.put("explain_spmh_hours_planned", Res.string.explain_spmh_hours_planned)
}
